import React from 'react';
import {Flex, ToogleSwitch} from '/app/src/component'
import UserModel from '/app/src/model/User/model'
import UserSelector from '/app/src/model/User/selector'
import {connect} from 'react-redux';

import {checkPermission} from '/app/src/lib/WebNotification/notification'


class Notifications extends React.Component {
    render() {
        return <Flex width='100%' column hAlignContent='center'>
            <Flex marginTop='10%' width='60%'>
                <Flex basis='30%' vAlignContent='center' hAlignContent='left'>
                    <ToogleSwitch
                        on={this.props.soundOn}
                        manual={true}
                        onChange={() => this.props.dispatch(UserModel.muteNotifications(!this.props.soundOn))}
                        colorOff={'#CECECE'}
                    />
                </Flex>
                <Flex column basis='70%'>
                    <Flex color='black' fontSize='24px' fontWeight='300'>Notifikationsljud</Flex>
                    <Flex color='black' fontSize='18px' my='5px' mb='20px'> Ljud spelas upp när du får nya meddelanden. </Flex>
                </Flex>
            </Flex>
            <Flex marginTop='25px' width='60%'>
                <Flex basis='30%' vAlignContent='center' hAlignContent='left'>
                    <ToogleSwitch
                        on={this.props.notifyOn && checkPermission() === 'granted'}
                        manual={true}
                        onChange={() => this.props.dispatch(UserModel.killNotifications(!this.props.notifyOn, true))}
                        colorOff={'#CECECE'}
                    />
                </Flex>
                <Flex column basis='70%'>
                    <Flex color='black' fontSize='24px' fontWeight='300'>Avisering på skrivbordet</Flex>
                    <Flex color='black' fontSize='18px' my='5px' mb='20px'> En avisering visas när du får nya meddelanden.</Flex>
                </Flex>
            </Flex>
        </Flex>
    }
}

function mapStateToProps(state) {
    const soundOn = UserSelector.soundNotifyIsOn(state)
    const notifyOn = UserSelector.webNotifyIsOn(state)
    return {
        soundOn: soundOn,
        notifyOn: notifyOn
    }
}
export default connect(mapStateToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/UserRoute/Notifications/index.js